module.exports = __webpack_public_path__ + "img/asippindo2.63952032.png";